import React from "react";
import { RouteComponentProps } from "react-router";

import UserFormScreen from "./UserFormScreen";
import { EmptyState, Link, ScreenContainer } from "../components/wombat-ui";
import useTranslations from "../hooks/useTranslations";
import { useBreadcrumbs } from "../hooks/useBreadcrumbs";
import { useGetUser } from '../graphql/generated/definitions';

type EditUserScreenProps = RouteComponentProps<{ id: string }>;

const EditUserScreen: React.FC<EditUserScreenProps> = ({ match }) => {
  const t = useTranslations();
  const { data: userData, loading } = useGetUser({
    variables: { id: match.params.id },
  });

  const user = userData?.user;

  useBreadcrumbs([
    {
      to: "/users",
      text: t('users.header') as string,
    },
    {
      to: `/users/${match.params.id}`,
      text: user?.name,
    },
    {
      to: `/users/${match.params.id}/edit`,
      text: t('forms.actions.edit') as string,
    },
  ]);

  return (
    <ScreenContainer
      loading={loading}
      error={
        !user?.canInsert ? (
          <EmptyState
            title={t("network.unauthorized") as string}
            action={
              <Link variant="button" to="/">
                {t("network.backToHome")}
              </Link>
            }
          />
        ) : undefined
      }
    >
      {user && <UserFormScreen defaultValues={{...user}} />}
    </ScreenContainer>
  );
};

export default React.memo(EditUserScreen);
